import React from 'react';
import styled, { css, StyledComponents } from '@benzinga/themetron';

export interface CodeBlockProps {
  attrs?: {
    language: 'sass' | 'css';
    source: string;
  };
}

export const CodeBlock: React.FC<CodeBlockProps> = ({ attrs }) => {
  const acceptedStyleLanguages = ['sass', 'css'];
  if (attrs?.language && acceptedStyleLanguages.includes(attrs.language)) {
    const StyledComponentsCSS = css`
      ${attrs.source}
    `;
    return <Style style={StyledComponentsCSS} />;
  }
  return <Container className="code-block"></Container>;
};

const Style = StyledComponents.createGlobalStyle<{ style: StyledComponents.RuleSet<object> }>`
body {
  ${props => (props?.style ? props?.style : '')};
}
`;

export const Container = styled.div``;
